module.exports = [{"label":"Hide","value":-1},{"label":"Show","value":1}]


//////////////////
// WEBPACK FOOTER
// ./src/content/projects/2019/NED-0534-got-show-matcher/button-values.json
// module id = Xd1P
// module chunks = 0